<template>
  <div style="font-size: 16px; position: relative">
    <div class="content-bg" :style="'width:' + this.width + '%;height:' + this.height + 'px;background:url(' + this.src + ');background-size:100% 100%'">
      <div class="content-bg-mark flex flex-justify-content flex-align-items"  :class="'jb-'+jb">
        <slot  name="one" class="title"></slot>
        <slot  name="two">
<!--          <img  width="50" height="15" src="https://cdn.blanda.com.cn/assets/img/pub/rightjt.png" alt="">-->
        </slot>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'ContentImg',
  props: {
    width: {
      type: String,
      default: 300,
    },
    height: {
      type: String,
      default: 300,
    },
    jb: {
      type: String,
      default: '1',
    },
    src: {
      type: String,
      default: '',
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bannereSrc:'https://cdn.blanda.com.cn/assets/img/index/banner.png',
      aa:'https://cdn.blanda.com.cn/assets/img/index/banner.png',
      stat:true,
    };
  },
  computed: {

  },
  methods: {

  },
  watch:{
    width:{
      handler(newValue,oldValue){
        console.log('widthsnewValue',newValue)
      },
      deep:true
    }
  }
}
</script>

<style scoped>
.content-bg{
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  transition:top .3s;
  top: 0px;
}
.content-bg:hover{
  position: relative;
  top: -10px;
}
.trans{
  transform:rotate(90deg);
  color: #ffffff;
  font-size: 50px;
}
.content-bg>div{
  font-size: 32px;
  color: #FFFFFF;
}
.content-bg>img{
  /*width: 30px;*/
  /*height: 10px;*/
}
.content-bg-mark{
  width: 100%;
  height: 100%;
  border-radius: 10px;
  flex-flow: column;
}
.jb-1{
  background: linear-gradient(90deg, rgba(10, 10, 10, 0.5) 0%, rgba(10, 10, 10, 0.5) 100%);
}
.jb-2{
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.65) 100%);
}

</style>
